class ProductReviews extends HTMLElement {
  constructor() {
    super();

    this.etrustedWidget = null;
    this.etrustedProductReviewListWidget = null;
  }

  connectedCallback() {
    this.etrustedWidget = this.querySelector('etrusted-widget');

    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'attributes') {
          this.setCustomStyle();
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(this.etrustedWidget, { attributes: true, childList: true, subtree: true });
  }

  disconnectedCallback() {}

  setCustomStyle() {
    this.etrustedProductReviewListWidget = this.etrustedWidget.application;

    if (!this.etrustedProductReviewListWidget) return;

    this.etrustedProductReviewListWidget.setAttribute('style', '--accent-color: #E6C475;');
  }
}

customElements.define('product-reviews', ProductReviews);
